import React, { useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { Copy, Square, Stack } from '@grubhubprod/gh-cookbook-react';
import { useAuth } from 'src/components/AuthProvider/AuthProvider';
import { useAnalytics } from 'src/components/AnalyticsProvider/AnalyticsProvider';
import PageHeader from 'src/components/enterprise/layout/PageHeader';
import { PageTitle } from 'src/components/enterprise/layout/PageTitle/PageTitle';
import { RouterLink } from 'src/components/RouterLink/RouterLink';
import PageSection from 'src/components/enterprise/layout/PageSection';
import { useFeatureFlag } from 'src/hooks/useFeatureFlag';
import { FeatureFlag } from 'src/types/FeatureFlag';
import { OnboardingFunnelWrapper } from 'src/components/enterprise/features/HomePage/components/OnboardingFunnelWrapper/OnboardingFunnelWrapper';
import { BusinessAdminInsights } from 'src/components/enterprise/features/HomePage/BusinessAdminInsights/components/BusinessAdminInsights/BusinessAdminInsights';
import { SubscriptionBanner } from './components/SubscriptionBanner';
import { HelpInfoSection } from './components/HelpInfoSection';

export const PARENT_ACCOUNTS_URL = '/corporate/enterprise/parents/accounts';

export const EnterpriseHomePage: React.FC = () => {
  const { corpid: urlCorpId } = useParams<{ corpid: string }>();
  const {
    corpData,
    corpId,
    enterpriseData: { isParentAdminUser },
  } = useAuth();
  const { sendTealiumPageView } = useAnalytics();
  const { value: isBusinessAdminInsightsEnabled } = useFeatureFlag(
    FeatureFlag.ENABLE_BUSINESS_INSIGHTS
  );

  useEffect(() => {
    sendTealiumPageView({
      pagegroup: 'corporate admin',
      pagesubgroup: 'corporate admin home',
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const showSubscriptionBanner = corpData?.ghPlusEnabled;
  const isParentCorp = corpData?.childAccountsEnabled;
  const showBusinessAdminInsights =
    isBusinessAdminInsightsEnabled && !isParentCorp;

  return (
    <Square inset="lg">
      <Stack y="lg">
        <PageHeader>
          <PageTitle title={`Welcome ${corpData?.name},`} />
          {isParentAdminUser && (
            <Stack y="sm">
              <Copy variant="body">
                <RouterLink href={PARENT_ACCOUNTS_URL}>
                  All parent accounts
                </RouterLink>
              </Copy>
            </Stack>
          )}
          {showBusinessAdminInsights && (
            <Stack y="lg">
              <Copy variant="body">
                Your meal program dashboard—track spend, manage budgets, and
                monitor usage.
              </Copy>
            </Stack>
          )}
        </PageHeader>

        <OnboardingFunnelWrapper corpId={urlCorpId || corpId} />
        {showBusinessAdminInsights && <BusinessAdminInsights />}
        {showSubscriptionBanner && (
          <Stack y="md">
            <PageSection>
              <SubscriptionBanner brand={corpData.brand} />
            </PageSection>
          </Stack>
        )}
        <Stack y="md">
          <PageSection>
            <HelpInfoSection />
          </PageSection>
        </Stack>
      </Stack>
    </Square>
  );
};
